import { HttpHeaders } from '@angular/common/http';

export class RestResponse<T> {
    body: T;
    headers: any;

    constructor(_body: T, _headers: any) {
        this.body = _body;
        this.headers = _headers;
    }

}